<template>
  <app-alert
      :show="show"
      title="Passwort vergessen"
      show-cancel
      @ok="onOk"
      @cancel="onCancel"
  >
    <form class="form" @submit.prevent="onOk">
      <label>
        E-Mail Adresse
        <input type="text" v-model="email" autofocus>
      </label>
    </form>
  </app-alert>
</template>

<script lang="ts" setup>
import AppAlert from "@/components/AppAlert.vue";
import {computed, ref} from "vue";
import {useStore} from "vuex";

const props = withDefaults(defineProps<{
  show?: boolean
}>(), {
  show: false
})

const emit = defineEmits<{
  ok: [ email: string ]
  cancel: []
}>()

const store = useStore()

const email = ref<string>('')

const configuration = computed(() => store.state.configuration)
if (configuration.value) {
  email.value = configuration.value.user.email
}

const onOk = () => {
  emit('ok', email.value)
  email.value = ''
}
const onCancel = () => {
  emit('cancel')
}
</script>
